import axios from 'axios';
import config from 'config';

const setKongToken = async (
  userId: string,
  sessionToken: string,
  accountId: string
) => {
  const endpoint = config.proxyOrigin.replace('/v1', '') + '/redis/set-token';
  return axios.put(endpoint, [{ [`${userId}:${sessionToken}`]: accountId }]);
};

export default setKongToken;
